/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import type { PropsWithChildren } from 'react';

import { css, jsx } from '@compiled/react';

const MenuWrapper = ({ children }: PropsWithChildren<{}>) => (
	<div css={menuWrapperStyles}>{children}</div>
);

const menuWrapperStyles = css({
	display: 'var(--display-menu)',
});

export default MenuWrapper;
